<template>
	<div>
		<layout-1 :table_name="'Boxes'" :id=pageid :searchbar=true :button_perm="'88'" :button_name="'Edit'" :term=term :reroute="'/0325'" :select_reroute=true style="width:100%; height:calc(100vh - 50px);"></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.INVENTORY_BOX_PAGE
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Inventory_Boxes.vue